
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[...catalog_query]",
      function () {
        return require("private-next-pages/catalog/[...catalog_query]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/[...catalog_query]"])
      });
    }
  